import React from "react";

import { ReactComponent as Close } from "../assets/icons/cross.svg";

export default function Modal({
  visible,
  onClose,
  title,
  children,
  Action,
  horizontal = false,
}) {
  return (
    <>
      <div
        className={`fixed top-0 left-0 w-screen h-screen bg-[#333]/80 transition-opacity ${
          visible ? "opacity-100" : "hidden opacity-0"
        }`}
      />
      <div
        className={`flex flex-col absolute ${
          horizontal
            ? "bottom-0 w-screen h-[500px] "
            : "top-0 w-[440px] h-screen"
        } bg-background right-0 transition-transform ${
          horizontal
            ? visible
              ? "translate-y-0"
              : "translate-y-[500px]"
            : visible
            ? "translate-x-0"
            : "translate-x-[440px]"
        }`}
      >
        <div className="flex p-5 justify-end">
          <button onClick={onClose}>
            <Close className="w-4 h-4 fill-white" />
          </button>
        </div>
        <h1
          className={`font-bold text-white text-xl px-16 ${
            horizontal ? "mb-4" : "mb-11"
          }`}
        >
          {title}
        </h1>
        <div className="px-16 grow overflow-y-auto">{children}</div>
        <div className="px-16 pb-14">{Action}</div>
      </div>
    </>
  );
}
